<template>
  <div class="home">
    <Menu></Menu>
    <div v-show="showList">
      <h2>ACSW Officials</h2>
    </div>
    <div>
      <v-expansion-panels>
        <v-expansion-panel
            v-for="role in officials" :key="role.code"
        >
          <v-expansion-panel-header>
            <h4>{{ role.roleName }}</h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content v-for="official in role.members" :key="official.id" no-gutters>
            <v-row no-gutters>
              <v-col cols="12" sm="3" align="left">{{ official.fullName }}</v-col>
              <v-col cols="12" sm="3" v-show="maySeeDetail" align="left">{{ official.email }}</v-col>
              <v-col cols="12" sm="2" v-show="maySeeDetail" align="left">{{ official.phone }}</v-col>
              <v-col cols="12" sm="3" v-show="maySeeDetail" align="left">{{ official.city }}</v-col>
              <v-col cols="12" sm="1" align="left">{{ official.state }}</v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'

export default {
  name: "Officials",
  components: {
    Menu,
  },
  data: () => ({
    officials: null,
    showList: true,
  }),
  mounted: function () {
    console.log('Officials mounted')
    if (this.$usrStore.token == null) {
      if (localStorage.getItem('token') !== 'undefined') {
        if (localStorage.getItem('token').length > 4) {
          this.$initFromToken(localStorage.getItem('token'))
        }
      }
    }
    this.loadAll()
  },

  computed: {
    maySeeDetail() {
      return this.$hasRole(['adm','sys','Host'])
    },
  },

  methods: {
    loadAll: function () {
      this.loadOfficials()
    },
    sortOfc() {
      for(let i= 0; i< this.officials.length; i++){
        let role = this.officials[i]
        let holders = role.members
        holders.sort(function (a,b){ if(a.fullName < b.fullName) {return -1} else {return 1}})
        console.log(holders)
      }
    },
    loadOfficials: async function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/mbrsbyrole', {
        token: theToken
      })
          .then(response => {
            console.log('Got response from mbrsbyrole')
            this.officials = response.data.officials
            this.sortOfc()
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
  }
}
</script>

<style scoped>

</style>